import React, { useState } from "react";
import HomePageCatagoryCard from "../HomePageCatagoryCard";
import styles from "./homepagecatagory.module.css";
import { useTranslation } from "react-i18next";

const HomePageCatagory = ({ categories }) => {
  const { t } = useTranslation();
  const visibleCards = 12;
  const stepSize = 2;
  const [startIndex, setStartIndex] = useState(0);

  const handleNext = () => {
    if (startIndex + visibleCards < categories.length) {
      setStartIndex(startIndex + stepSize);
    }
  };

  const handlePrev = () => {
    if (startIndex - stepSize >= 0) {
      setStartIndex(startIndex - stepSize);
    }
  };

  const visibleCategories = categories.slice(
    startIndex,
    startIndex + visibleCards
  );

  return (
    <div className="container-fluid mt-3vw">
      <h3 className={styles.mt}>{t("category")}</h3>
      <div className={styles.carouselContainer}>
        <button
          onClick={handlePrev}
          className={styles.carouselButton}
          disabled={startIndex === 0}
        >
          {"<"}
        </button>
        <div className={styles.cardContainer}>
          <div className="row">
            {visibleCategories.map((category, idx) => (
              <div className="col-md-2" key={idx}>
                <HomePageCatagoryCard
                  img={category.imageURL}
                  text={category.name}
                />
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={handleNext}
          className={styles.carouselButton}
          disabled={startIndex + visibleCards >= categories.length}
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default HomePageCatagory;
